import { connect, mapProps } from '@formily/react';
import { CnAsyncSelect as UiAsyncSelect } from '@/components/cn-async-select';
import { mapSize, mapStatus } from '@/form/__builtins__';
export var CnAsyncSelect = connect(UiAsyncSelect, mapProps(mapSize, mapStatus, {
    dataSource: true,
}));
CnAsyncSelect.displayName = 'CnAsyncSelect';
